module.exports = __webpack_public_path__ + "static/media/discover-screenshot-beliebers.b517d50b.png";